export default __webpack_public_path__ + "static/media/circle.c22384bb.png";